import { render, staticRenderFns } from "./ShippingPlanList.vue?vue&type=template&id=48a7c606&scoped=true&"
import script from "./ShippingPlanList.vue?vue&type=script&lang=js&"
export * from "./ShippingPlanList.vue?vue&type=script&lang=js&"
import style0 from "./ShippingPlanList.vue?vue&type=style&index=0&id=48a7c606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a7c606",
  null
  
)

export default component.exports